/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Nodeupdated1Inputs */

const zh_course_nodeupdated1 = /** @type {(inputs: Course_Nodeupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节点已更新`)
};

const en_course_nodeupdated1 = /** @type {(inputs: Course_Nodeupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Node updated`)
};

const es_course_nodeupdated1 = /** @type {(inputs: Course_Nodeupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodo actualizado`)
};

/**
* | output |
* | --- |
* | "Node updated" |
*
* @param {Course_Nodeupdated1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_nodeupdated1 = /** @type {((inputs?: Course_Nodeupdated1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Nodeupdated1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_nodeupdated1(inputs)
	if (locale === "en") return en_course_nodeupdated1(inputs)
	return es_course_nodeupdated1(inputs)
});
export { course_nodeupdated1 as "course_nodeUpdated" }